import * as actionTypes from '../constants/actionTypes';
export function flashHotspots() {
    return {
        type: actionTypes.FLASH_HOTSPOTS,
    };
}
export function showHotspots() {
    return {
        type: actionTypes.SHOW_HOTSPOTS,
    };
}
export function hideHotspots() {
    return {
        type: actionTypes.HIDE_HOTSPOTS,
    };
}
export function loadHotspotsStarting() {
    return {
        type: actionTypes.LOAD_HOTSPOTS_STARTING,
    };
}
export function loadHotspotsFailed() {
    return {
        type: actionTypes.LOAD_HOTSPOTS_FAILED,
    };
}
export function loadHotspotsDone() {
    return {
        type: actionTypes.LOAD_HOTSPOTS_DONE,
    };
}
